import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import * as Sentry from "@sentry/react";

import { AuthProvider } from "@/auth/AuthProvider";
import { ConfirmDialogProvider } from "@/components/ConfirmDialog";
import { router } from "@/router";
import "./styles.css";

const dsn = (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? "";
const env = (import.meta.env.VITE_BACKSTAGE_ENV as string | undefined) ?? "local";
const release = (import.meta.env.VITE_RELEASE as string | undefined) ?? "0.0.0";

if (dsn) {
  Sentry.init({
    dsn,
    environment: env,
    release: `backstage-webui@${release}`,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p style={{ padding: 16 }}>UI error. Reload.</p>}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ConfirmDialogProvider>
            <RouterProvider router={router} />
          </ConfirmDialogProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
